import { render, staticRenderFns } from "./CartItemStatistics.vue?vue&type=template&id=f8fb7b14&scoped=true&"
import script from "./CartItemStatistics.vue?vue&type=script&lang=js&"
export * from "./CartItemStatistics.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/statistics.styl?vue&type=style&index=0&id=f8fb7b14&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fb7b14",
  null
  
)

export default component.exports